<template>
  <app-layout page="home">
    <header class="relative pt-28 lg:pt-40 lg:pb-32 overflow-hidden">
      <div class="absolute bg-cover bg-no-repeat bg-center inset-0 bg-image z-0"></div>
      <div class="absolute hidden md:block inset-0 z-0">
        <video autoplay muted loop class="h-full w-full object-cover object-right">
          <source src="/video-header.mp4"/>
        </video>
      </div>
      <div class="absolute inset-0 bg-black bg-opacity-20 z-0"></div>
      <div class="header-content lg:max-w-3/4 mx-auto flex flex-col lg:flex-row items-center relative z-10">
        <div class="w-10/12 lg:w-7/12 py-12 text-center lg:text-left">
          <h1 class="font-bold text-white text-3xl lg:text-5xl lg:mb-12 mb-6">
            {{ translate(content.home_main_title, $locale()) }}</h1>
          <h2 class="font-sans font-semibold text-white text-xl mb-10 max-w-sm mx-auto md:mx-0">Testez et optimisez
            votre
            intelligence émotionnelle
            avec AGEM®.</h2>
          <div class="flex">
            <a class="px-8 py-4 text-lg font-bold text-white uppercase"
               href="https://calendly.com/talents-carriere/donnez-une-nouvelle-trajectoire"
               target="_blank"
               style="background-color: #96364b"
            >
              Je prends rendez-vous
            </a>
          </div>
        </div>
      </div>
      <div
          class="lg:absolute relative z-10 lg:right-0 lg:top-1/3 py-10 w-full lg:w-5/12 lg:bg-opacity-80 bg-dark-blue mt-24 lg:mt-0">
        <img src="/images/label-agem.png" alt="Label AGEM"
             class="lg:absolute w-48 transform -mt-32 lg:-mt-24 lg:left-80 mx-auto lg:mx-0">
        <ul class="max-w-xs pl-16 text-white space-y-6 list-disc">
          <li>Développez vos <strong>7 talents</strong> en intelligence émotionnelle</li>
          <li><strong>Interagissez</strong> directement avec un coach</li>
          <li><strong>Améliorez votre vie</strong> professionnelle et personnelle</li>
        </ul>
      </div>
    </header>

    <!-- Develop you skills -->
    <section-explanation id="what-is-it" :reverse="true" :cta="false" class="my-12">
      <template #title>
        {{ translate(content.section_1_title, $locale()) }}
      </template>
      <template #side>
        <div class="bg-dark-blue p-6">
          <h3 class="text-white font-bastia text-2xl">{{ translate(content.section_1_side_title, $locale()) }}</h3>
          <ul>
            <li v-for="skill in skills" class="flex items-center text-white my-8">
              <img :src="`/storage/${skill.icon_path}`" :alt="skill.title[$locale()]" class="mr-4 h-6">
              {{ skill.title[$locale()] }}
            </li>
          </ul>
          <!--<div class="flex mt-12">-->
          <!--  <bubble-link :href="route('survey.start', surveys[0].slug)" type="inverted" class="mx-auto">{{-->
          <!--      $trans('app.start')-->
          <!--    }}-->
          <!--  </bubble-link>-->
          <!--</div>-->
        </div>
      </template>
      <template #content>
        <div class="block w-full mx-auto">
          <video-player :options="videoOptions1" class="h-full mx-auto">
            <source src="/what-is-emotional-intelligence.mp4" type="video/mp4">
          </video-player>
        </div>
        <p class="mt-8" v-html="translate(content.section_1_content , $locale())"></p>
      </template>
    </section-explanation>

    <!-- Packages -->
    <!--<div class="mt-6 relative flex flex-wrap lg:pt-12 pb-12 lg:pb-24 w-full" id="pricing">-->
    <!--  <div class="bg-dark-blue w-auto lg:w-3/5 absolute inset-0 z-0 -ml-4">-->
    <!--  </div>-->
    <!--  <div class="flex flex-col justify-end px-6 lg:px-20 xl:max-w-3/4 lg:mx-auto z-10">-->
    <!--    <div class="py-10 relative">-->
    <!--      <h2 class="text-beige">Nos formules</h2>-->
    <!--    </div>-->

    <!--    <div-->
    <!--        class="flex flex-wrap lg:flex-nowrap items-center lg:justify-around justify-center space-y-2 lg:space-y-0 lg:space-x-4 bg-beige p-5 my-4 rounded shadow-lg">-->
    <!--      <bullet-point bullet-color="text-medium-blue">{{ $trans('app.packages.pay-difference') }}</bullet-point>-->
    <!--      <bullet-point bullet-color="text-medium-blue">{{ $trans('app.packages.results-247') }}</bullet-point>-->
    <!--    </div>-->

    <!--    <div class="">-->
    <!--      <pricing-cards :prices="prices">-->
    <!--        &lt;!&ndash;<template #diamond-package>&ndash;&gt;-->
    <!--        &lt;!&ndash;    <bubble-button @click.prevent="buy('diamond')">{{$trans('app.choose-package')}}</bubble-button>&ndash;&gt;-->
    <!--        &lt;!&ndash;</template>&ndash;&gt;-->
    <!--        <template #gold-package>-->
    <!--          <bubble-button @click.prevent="buy('gold')">{{ $trans('app.choose-package') }}</bubble-button>-->
    <!--        </template>-->
    <!--        <template #silver-package>-->
    <!--          <bubble-button @click.prevent="buy('silver')">{{ $trans('app.choose-package') }}</bubble-button>-->
    <!--        </template>-->
    <!--        <template #bronze-package>-->
    <!--          <bubble-link :href="route('survey.start', { survey: surveys[0].slug, package: 'bronze' })">-->
    <!--            {{ $trans('app.start') }}-->
    <!--          </bubble-link>-->
    <!--        </template>-->
    <!--      </pricing-cards>-->
    <!--    </div>-->

    <!--  </div>-->
    <!--</div>-->

    <!-- How it works -->
    <section-explanation id="how-it-works" :reverse="true" class="my-10">
      <template #title>
        {{ $trans('app.menu.how-it-works') }}
      </template>
      <template #side>
        <img src="/images/how-it-works.jpg" alt="Comment ça marche ?"
             class="hidden lg:block w-full max-h-96 object-cover">
      </template>
      <template #content>
        <div class="flex items-center">
          <a :href="route('survey.start', surveys[0].slug)" class="mr-8">
            <p class="flex items-center justify-center font-bold text-3xl text-white font-bastia rounded-full bg-dark-blue h-16 w-16 mx-auto">
              1</p>
          </a>
          <div>
            <h3 class="my-3">{{ translate(content.how_it_works_1_title, $locale()) }}</h3>
            <p>{{ translate(content.how_it_works_1_content, $locale()) }}</p>
          </div>
        </div>

        <div class="flex items-center mt-12">
          <a :href="route('survey.start', surveys[0].slug)" class="mr-8">
            <p class="flex items-center justify-center font-bold text-3xl text-white font-bastia rounded-full bg-dark-blue h-16 w-16 mx-auto">
              2</p>
          </a>
          <div>
            <h3 class="my-3">{{ translate(content.how_it_works_2_title, $locale()) }}</h3>
            <p>{{ translate(content.how_it_works_2_content, $locale()) }}</p>
          </div>
        </div>

        <div class="flex items-center mt-12">
          <a :href="route('survey.start', surveys[0].slug)" class="mr-8">
            <p class="flex items-center justify-center font-bold text-3xl text-white font-bastia rounded-full bg-dark-blue h-16 w-16 mx-auto">
              3</p>
          </a>
          <div>
            <h3 class="my-3">{{ translate(content.how_it_works_3_title, $locale()) }}</h3>
            <p>{{ translate(content.how_it_works_3_content, $locale()) }}</p>
          </div>
        </div>

        <div class="mt-12 w-full text-center">
          <a class="px-6 md:px-8 py-4 text-base md:text-lg font-bold text-white uppercase"
             href="https://calendly.com/talents-carriere/donnez-une-nouvelle-trajectoire"
             target="_blank"
             style="background-color: #96364b"
          >
            Je prends rendez-vous
          </a>
        </div>
      </template>
    </section-explanation>


    <!-- Who we are -->
    <section-explanation id="who-we-are" :inverted="true" :full-w="true" container-classes="w-full lg:w-2/5"
                         side-width="w-full" class="mt-10 mb-40">
      <template #title>
        {{ translate(content.section_2_title, $locale()) }}
      </template>
      <template #side>
        <div class="lg:-ml-40 w-full lg:w-2/3 max-w-3xl">
          <video-player :options="videoOptions2">
            <source src="/who-are-we.mp4" type="video/mp4">
          </video-player>
          <!--<img src="/images/label-agem.png" alt="Label AGEM" class="hidden lg:block w-48 ml-52 mt-6">-->
        </div>
      </template>
      <template #content>
        <div class="w-full lg:w-2/3">
          <p v-html="translate(content.section_2_content , $locale())"></p>
        </div>
      </template>
    </section-explanation>


    <!-- Testimonials -->
    <div class="py-10 lg:my-10 overflow-hidden lg:mx-auto" id="testimonials" v-if="reviews && reviews.length > 0">
      <h2 class="text-dark-blue max-w-xl lg:mb-10 xl:max-w-3/4 mx-auto px-20">Témoignages</h2>
      <div class="overflow-x-scroll flex items-stretch mt-6 lg:mt-0 space-x-4 lg:pl-20 pl-4">
        <review-card v-for="review in reviews" :name="review.name" :type="review.type" :content="review.content"
                     :video="review.video_url"/>
      </div>
    </div>


  </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PricingCards from "@/Components/PricingCards";
import BubbleLink from "@/Components/BubbleLink";
import BubbleButton from "@/Components/BubbleButton";
import ReviewCard from "@/Components/ReviewCard";
import SectionExplanation from "@/Components/SectionExplanation";
import VideoPlayer from "@/Components/VideoPlayer";
import BulletPoint from "@/Components/BulletPoint";

export default {
  components: {
    SectionExplanation,
    ReviewCard,
    AppLayout,
    PricingCards,
    BubbleLink,
    BubbleButton,
    VideoPlayer,
    BulletPoint
  },
  name: "Home",
  props: ['surveys', 'content', 'reviews', 'prices', 'skills'],
  mounted() {
    // let stripeScript = document.createElement('script')
    // stripeScript.setAttribute('src', 'https://js.stripe.com/v3/')
    // document.head.appendChild(stripeScript)
  },

  data() {
    return {
      // videoOptionsHeader: {
      //     controls: false,
      //     fluid: false,
      //     autoplay: true,
      //     muted: true,
      //     loop: true
      // },
      videoOptions1: {
        controls: true,
        fluid: true,
        height: 200,
        poster: "/images/video-develop-talents-thumb.png"
      },
      videoOptions2: {
        controls: true,
        fluid: true,
        height: 200,
        poster: "/images/talentueusement-votre.png"
      },
    }
  },

  methods: {
    buy(formula) {
      // Create an instance of the Stripe object with your publishable API key
      const stripe = Stripe(process.env.MIX_STRIPE_KEY);

      axios.post(route('packages.buy'), {package: formula, survey: this.surveys[0].id})
          .then(function (session) {
            return stripe.redirectToCheckout({sessionId: session.data.id});
          })
          .then(function (result) {
            // If redirectToCheckout fails due to a browser or network
            // error, you should display the localized error message to your
            // customer using error.message.
            if (result.error) {
              alert(result.error.message);
            }
          })
          .catch(function (error) {
            console.error("Error:", error);
          });
    }
  }
}
</script>

<style lang="scss" scoped>
.scroller {
  animation: 30s scroll infinite alternate;
  animation-timing-function: linear;
}

@keyframes scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
}

.bg-image {
  background-image: url('/images/bg-header-mobile.jpg');
  @screen lg {
    background-image: url('/images/bg-header.jpg');
  }
}

</style>
